import { useEffect, useState } from "react"
import { CustomDialog } from "../../../components/customDialog/CustomDialog"
import { Box, CircularProgress, IconButton, Typography } from "@mui/material";
import { InfoBox } from "../../EnvioCreation/components/InfoBox";
import GET_NOVEDADES_VISITA, { adaptNovedadesVisita } from "../../../data/graphQL/queries/ControlVisitas/getNovedadesVisita";
import { useLazyQuery, useMutation } from "@apollo/client/react";
import CREATE_NOVEDAD_VISITA from "../../../data/graphQL/mutations/ControlVisita/createNovedadVisita";
import { RenderInputByTypeMobile } from "../../../components/formGroupGenerator/RenderInputByTypeMobile";
import toast from "react-hot-toast";
import moment from "moment";
import CloseIcon from '@mui/icons-material/Close';

const Comentario = ({ autor, fecha, texto, matricula }) => {
    return (
        <Box
            sx={{
                backgroundColor: '#F9FAFB',
                border: '1px solid #E5E7EB',
                borderRadius: '12px',
                padding: '16px',
                boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.04)',
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    columnGap: '6px',
                }}
            >
                <Typography
                    sx={{
                        fontSize: '14px',
                        fontWeight: 600,
                        color: '#111827',
                        fontFamily: 'system-ui'
                    }}
                >
                    {autor}
                </Typography>

                <Typography
                    sx={{
                        fontSize: '12px',
                        fontWeight: 500,
                        color: '#5E6063',
                        fontFamily: 'system-ui'
                    }}
                >
                    • {fecha}
                </Typography>
                <Typography
                    sx={{
                        fontSize: "12px",
                        color: " #919191",
                        fontFamily: "system-ui",
                        flexBasis: "100%"
                    }}
                >{matricula}</Typography>
            </Box>
            <Typography
                sx={{
                    fontSize: '14px',
                    fontWeight: 400,
                    color: '#484e58',
                    lineHeight: '20px',
                    whiteSpace: 'pre-wrap',
                    fontFamily: 'system-ui'
                }}
            >
                {texto}
            </Typography>
        </Box>
    );
};


export const NovedadesVisitaModal = ({
    novedadesSettings,
    resetNovedadesSettings,
}) => {

    const [novedades, setNovedades] = useState([]);
    const [nuevaNovedad, setNuevaNovedad] = useState('');

    const [getNovedades, { loading }] = useLazyQuery(GET_NOVEDADES_VISITA, {
        fetchPolicy: 'no-cache'
    });
    const [createNovedad, { loading: createLoading }] = useMutation(CREATE_NOVEDAD_VISITA);

    const fetchNovedades = async () => {
        try {
            const { data } = await getNovedades({
                variables: { idVisita: novedadesSettings.idVisita }
            });
            console.log(adaptNovedadesVisita(data.novedadVisitas));

            setNovedades(adaptNovedadesVisita(data.novedadVisitas));
        } catch (err) {
            console.error('Error al cargar las novedades:', err);
        }
    }

    useEffect(() => {
        if (novedadesSettings.open && novedades.length === 0 && !loading) {
            fetchNovedades();
        }
    }, [novedadesSettings.open]);

    const guardarNovedad = async () => {
        try {

            await createNovedad({
                variables: {
                    input: {
                        idVisita: novedadesSettings.idVisita,
                        descripcion: nuevaNovedad
                    }
                }
            });

            await fetchNovedades();

            setNuevaNovedad('');
        } catch (err) {
            toast.error('Error al guardar la novedad:', err);
        }
    }

    return (
        <CustomDialog
            dialogTitle={<>
                Novedades de la visita
                <IconButton
                    onClick={resetNovedadesSettings}
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        color: '#6B7280',
                        '&:hover': {
                            backgroundColor: '#F3F4F6',
                        },
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </>}
            open={novedadesSettings.open}
            fullWidth
            maxWidth="sm"
            onCancel={resetNovedadesSettings}
            cancelText="Cerrar"
            acceptText="Agregar novedad"
            onAccept={guardarNovedad}
            acceptDisabled={!nuevaNovedad.trim().length}
            acceptLoading={createLoading}
            sxDialogContent={{ padding: '0 !important' }}
        >
            <Box
                display="flex"
                flexDirection="column"
                gap="20px"
                mb={2}
                px={2.5}
            >
                {loading && (
                    <Box display="flex" justifyContent="center" alignItems="center" py={4}>
                        <CircularProgress size={40} />
                    </Box>
                )}
                {!novedades.length && !loading && (
                    <Box display="flex" justifyContent="center" alignItems="center" py={6}>
                        <p style={{ fontSize: "14px", color: "#999" }}>Aún no hay novedades cargadas</p>
                    </Box>
                )}
                {!!novedades.length && (
                    [...novedades].sort((a, b) => b.idNovedad - a.idNovedad).map((novedad) =>
                        <Comentario
                            key={novedad.id}
                            autor={`${novedad.usuario.nombre} ${novedad.usuario.apellido}`}
                            matricula={novedad.matricula}
                            fecha={moment(novedad.fechaAlta).format('DD/MM/YYYY HH:mm') + 'hs'}
                            texto={novedad.descripcion}
                        />
                    )
                )}
            </Box>
            <Box sx={{
                position: 'sticky',
                bottom: '0px',
                padding: 1,
                paddingBottom: 0,
                background: 'white'
            }}
            >
                <RenderInputByTypeMobile
                    input={{
                        name: 'nuevaNovedad',
                        displayName: 'Nueva novedad...',
                        type: 'long_string',
                        longStringRows: 1
                    }}
                    handleChange={(_, value) => setNuevaNovedad(value)}
                    value={nuevaNovedad}
                />
            </Box>
        </CustomDialog>
    )
}